import { Component, OnDestroy, OnInit } from '@angular/core';
import { AgentDto } from '../../../../service/dto';
import { HttpAgentAdminService } from '../../../../service/http-agent.service';
import { HierarchyService } from '../../../../service/hierarchy.service';
import { Subscription, switchMap } from 'rxjs';

@Component({
	selector: 'app-agent-admin-list',
	standalone: false,
	templateUrl: './agent-admin-list.component.html',
	styleUrl: './agent-admin-list.component.scss'
})
export class AgentAdminListComponent implements OnInit, OnDestroy {
	data: AgentDto[] = [];
	subscription = new Subscription();
	constructor(private httpService: HttpAgentAdminService, private hierarchyService: HierarchyService) {

	}
	ngOnInit(): void {
		this.subscription.add(this.hierarchyService.hierarchy$
			.pipe(
				switchMap(item => this.httpService.getAll())
			)
			.subscribe(result => this.data = result));
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
